// extracted by mini-css-extract-plugin
export default {"register-form":"RegisterForm_register-form__N9fwE"};